import React from "react";

const UploadedHistoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 8.25H6L9 5.25L12 8.25H9.75V15.75H8.25V8.25ZM15 2.25V3.75L3 3.75V2.25L15 2.25Z"
        fill="rgb(20 123 255)"
      />
    </svg>
  );
};

export default UploadedHistoryIcon;
